import { render, staticRenderFns } from "./PartiesView.vue?vue&type=template&id=2607470e&scoped=true&"
import script from "./PartiesView.vue?vue&type=script&lang=js&"
export * from "./PartiesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2607470e",
  null
  
)

export default component.exports